import React from 'react'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import TextField from '@material-ui/core/TextField'

interface Props {
  value: string
  placeholder?: string
  icon?: React.ReactNode
  onChange: (text: string) => any // tslint:disable-line:no-any
}

const styles = (theme: Theme) => createStyles({
  // source: https://material-ui.com/demos/text-fields/#customized-inputs
  bootstrapRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing() * 3,
    },
    borderRadius: 4,
    backgroundColor: theme.palette.grey['200'],
    justifyContent: 'center',
    alignItems: 'center',
  },
  bootstrapInput: {
    fontSize: 16,
    padding: '14px 16px',
    width: 'calc(100% - 32px)',
    '&::-webkit-input-placeholder': { /* Chrome/Opera/Safari */
      textAlign: 'center',
    },
    '&::-moz-placeholder': { /* Firefox 19+ */
      textAlign: 'center',
    },
    '&:-ms-input-placeholder': { /* IE 10+ */
      textAlign: 'center',
    },
    '&:-moz-placeholder': { /* Firefox 18- */
      textAlign: 'center',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const TextInput: React.SFC<InjectedProps> = ({ value, icon, onChange, placeholder, classes }) => (
  <TextField
    fullWidth
    placeholder={placeholder}
    InputProps={{
      disableUnderline: true,
      classes: {
        root: classes.bootstrapRoot,
        input: classes.bootstrapInput,
      },
      startAdornment: icon,
    }}
    InputLabelProps={{
      shrink: true,
      className: classes.bootstrapFormLabel,
    }}
    onChange={(ev) => { onChange(ev.target.value) }}
    value={value}
  />
)

export default withStyles(styles)(TextInput)
